import { EnergyType } from '@essent/common';
import { createSelector } from '@ngrx/store';

import { getSupplyAddressVM } from '../address';
import { getCurrentContract } from '../current-contract/current-contract.selectors';
import { getRetentionState } from '../retention-feature.selector';

export const getCalculateState = createSelector(
  getRetentionState,
  (state) => state.calculate
);

export const getCalculateFormState = createSelector(
  getCalculateState,
  (state) => state.formState
);

export const getCalculateViewModel = createSelector(
  getSupplyAddressVM,
  getCalculateFormState,
  (supplyAddress, formState) => ({
    formState,
    supplyAddress,
  })
);

export const selectContractIncludesGas = createSelector(
  getCurrentContract,
  (contract) => !!contract?.commodities.includes(EnergyType.GAS)
);
